import { getNodeExpressionEvaluationContext, getNodeLayoutExpressionEvaluationContext, getProjectExpressionEvaluationContext, } from "../expression_engine/expression_context/ExpressionContextHelpers";
import PcbTreeManager from "../layout_engine/PcbTreeManager";
import { PcbLayoutRuleCompiler, PcbLayoutRuntimeRulesManager, RuleParser, } from "../layout_engine/rule_parsing_and_compilation";
export function wipeLocalRulesFromNodeType(nodeType, rulesToRemove, pcbLayoutNodes) {
    const newPcbLayoutNodes = {};
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    Object.entries(pcbLayoutNodes).forEach(([uid, node]) => {
        if (node.type === nodeType) {
            const newRuleSet = Object.fromEntries(Object.entries(node.pcbNodeRuleSet ?? {}).filter(([ruleKey]) => !rulesToRemove.includes(ruleKey)));
            newPcbLayoutNodes[uid] = {
                ...node,
                pcbNodeRuleSet: newRuleSet,
            };
        }
        else {
            newPcbLayoutNodes[uid] = node;
        }
    });
    return newPcbLayoutNodes;
}
/** Quickly sets up an environment to parse/bake rules for migration environments */
export function migrationParseRules(node, layoutRules, rulesToParse, pcbLayoutNodes, documentElements, documentData, logger) {
    const expressionEvaluationContext = {
        project: getProjectExpressionEvaluationContext(documentData),
        layout: node && node.uid
            ? getNodeLayoutExpressionEvaluationContext(node, { ...documentData, pcbLayoutNodes: pcbLayoutNodes, elements: documentElements }, logger)
            : undefined,
        this: node
            ? getNodeExpressionEvaluationContext(node, {}, { ...documentData, pcbLayoutNodes: pcbLayoutNodes, elements: documentElements }, logger)
            : undefined,
    };
    const parser = new RuleParser(layoutRules, expressionEvaluationContext, node.type);
    return parser.parseRules(rulesToParse);
}
/** Get the new default value for a rule, so we can avoid setting the rule if not necessary */
export function getExpectedNewRuleValue(node, ruleKey, pcbLayoutNodes, pcbLayoutRuleSets, documentElements, documentNets, documentData, logger) {
    const treeManager = new PcbTreeManager(pcbLayoutNodes, logger, true);
    const ruleCompiler = new PcbLayoutRuleCompiler(documentElements, documentNets, pcbLayoutRuleSets, treeManager.treeNodes, documentData, new PcbLayoutRuntimeRulesManager(), logger);
    const layoutRules = ruleCompiler.getFlattenedRules(node);
    const parsed = migrationParseRules(node, layoutRules, [ruleKey], pcbLayoutNodes, documentElements, documentData, logger);
    return parsed[ruleKey];
}
//# sourceMappingURL=ruleMigrations.js.map